const corpDocumentName = {
    "AccountOpeningForm":"Account Opening Form",
    "AcraReport":"ACRA Report",
    "CompanyRegistrationCertificate":"Company Registeration Certificate",
    "MemorandumAndArticlesOfAssociation":"Memorandum And ArticlesOfAssociation"
};
    export default corpDocumentName;